'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class, _class2, _temp2;

var _reactRedux = require('react-redux');

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _LoginSignup = require('./LoginSignup.scss');

var _LoginSignup2 = _interopRequireDefault(_LoginSignup);

var _reactIntl = require('react-intl');

var _session = require('redux/modules/session');

var sessionActions = _interopRequireWildcard(_session);

var _validation = require('utils/validation');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  Forgot: {
    displayName: 'Forgot'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Nav/Forgot.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

var Forgot = _wrapComponent('Forgot')((_dec = (0, _reactRedux.connect)(function (state) {
  return {
    errorForgot: state.session.errorForgot,
    forgotSent: state.session.forgotSent,
    messages: state.language.messages
  };
}, sessionActions), _dec2 = (0, _reactCssModules2.default)(_LoginSignup2.default), _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Forgot, _Component);

  function Forgot() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Forgot);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Forgot.__proto__ || (0, _getPrototypeOf2.default)(Forgot)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      errorMessage: '',
      emailError: false,
      emailErrorTemplateId: '',
      emailErrorTemplateValues: {}
    }, _this.onClose = function () {
      _this.props.openForgot(false);
    }, _this.handleSubmit = function (event) {
      event.preventDefault();
      if (_this.validateEmail()) {
        var email = _this.refs.email.value;
        _this.props.sendForgot({ email: email }).then(function () {
          _this.refs.email.value = '';
        }).catch(function (result) {
          _this.setState({ errorMessage: result.message });
        });
      }
    }, _this.validateEmail = function () {
      var email = _this.refs.email.value;
      var data = {
        email: {
          value: email,
          required: true,
          format: 'email',
          label: _this.props.messages['forgot.email.placeholder']
        }
      };
      var validatedData = (0, _validation.validateForm)(data);
      (0, _keys2.default)(validatedData).map(function (field) {
        if (field === 'formError') return;
        _this.setState((0, _defineProperty3.default)({}, field + 'Error', validatedData[field].error));
        _this.setState((0, _defineProperty3.default)({}, field + 'ErrorTemplateId', validatedData[field].templateId));
        _this.setState((0, _defineProperty3.default)({}, field + 'ErrorTemplateValues', validatedData[field].templateValues));
      });
      if (validatedData.formError) {
        return false;
      }
      return true;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Forgot, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          forgotSent = _props.forgotSent,
          messages = _props.messages;
      var _state = this.state,
          emailError = _state.emailError,
          emailErrorTemplateId = _state.emailErrorTemplateId,
          emailErrorTemplateValues = _state.emailErrorTemplateValues,
          errorMessage = _state.errorMessage;

      return _react3.default.createElement(
        'div',
        null,
        forgotSent ? _react3.default.createElement(
          'div',
          null,
          _react3.default.createElement(
            'h2',
            { styleName: 'header' },
            _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'forgot.sent.header' })
          ),
          _react3.default.createElement(
            'p',
            { styleName: 'subtitle' },
            _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'forgot.sent.description' })
          ),
          _react3.default.createElement(
            'div',
            { styleName: 'form' },
            _react3.default.createElement(
              'a',
              { styleName: 'btn-action', onClick: this.onClose },
              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'forgot.sent.close' })
            )
          )
        ) : _react3.default.createElement(
          'div',
          null,
          _react3.default.createElement(
            'h2',
            { styleName: 'header' },
            _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'forgot.header' })
          ),
          _react3.default.createElement(
            'p',
            { styleName: 'subtitle' },
            _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'forgot.description' })
          ),
          _react3.default.createElement(
            'form',
            { styleName: 'form', onSubmit: this.handleSubmit },
            _react3.default.createElement(
              'div',
              { styleName: 'input-container' },
              _react3.default.createElement('input', { styleName: emailError ? 'custom-input-error' : 'custom-input', placeholder: messages['forgot.email.placeholder'], type: 'text', ref: 'email' })
            ),
            emailError && _react3.default.createElement(
              'p',
              { styleName: 'error' },
              _react3.default.createElement(_reactIntl.FormattedMessage, { id: emailErrorTemplateId, values: emailErrorTemplateValues })
            ),
            errorMessage && _react3.default.createElement(
              'p',
              { styleName: 'error' },
              errorMessage
            ),
            _react3.default.createElement(
              'button',
              { type: 'submit', styleName: 'btn-action' },
              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'forgot.send' })
            )
          )
        )
      );
    }
  }]);
  return Forgot;
}(_react2.Component), _class2.propTypes = {
  forgotSent: _react2.PropTypes.bool,
  openForgot: _react2.PropTypes.func,
  sendForgot: _react2.PropTypes.func,
  messages: _react2.PropTypes.object
}, _temp2)) || _class) || _class));

exports.default = Forgot;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Nav/Forgot.js
// module id = 1567
// module chunks = 47